<template>
  <div class="mt-download-report__views-person">
    <div class="mt-download-report__views-person-label">{{ personReport.testTitle }}</div>
    <div class="mt-res-person-report-options">
      <div
        class="mt-res-person-report-options__option"
        v-for="report in personReport.reports"
        :key="report.variant"
      >
        <div
          class="mt-res-person-report-options__option-title"
        >
          {{ report.title }}
        </div>
        <div
            class="mt-res-person-report-options__option-title-test"
        >
          {{ report.testName }}
        </div>

        <mt-checkbox
          class="mt-res-person-report-options__option-action"
          v-model="report.selected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mtCheckbox from "@/components/UI/mtCheckbox/index.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    mtCheckbox
  },
  props: {
    personReport: {
      type: Object,
      default: () => ({})
    },
    view_download_html: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    ...mapGetters(["authUser", "isAdmin"])
  },

  watch: {},
  methods: {
    /* GETTERS */
    /* SETTERS */
    /* HANDLERS */
    /* HELPERS */
  },

  created() {
  },
  mounted() {
  }
};
</script>